import './ProjectDetailsImageSetTypeContainer.scss';
import { useTranslator } from '@Localization';
import { Option, Select } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useLoader } from '../../../../../helpers/useLoader';
import { useProjectDetailsPermissions } from '../../../projectDetails.permissions';
import { IProjectDetailsImagesBl } from '../projectDetailsImages.bl';
import { ImageSetType } from '../projectDetailsImages.model';
import { IProjectDetailsImagesStore } from '../projectDetailsImages.store';

export const ProjectDetailsImageSetTypeContainer = observer((): ReactElement => {
  const projectDetailsImagesBl = useInjection(IProjectDetailsImagesBl.$);
  const imagesStore = useInjection(IProjectDetailsImagesStore.$);
  const permissions = useProjectDetailsPermissions();

  const { t } = useTranslator();
  const { withLoaderAsync } = useLoader();

  const handleImagesSetTypeChanged = async (setType: ImageSetType): Promise<void> => {
    await withLoaderAsync(async () => projectDetailsImagesBl.updateBatchProjectImageSetAsync(setType), 'details-images-loading');
  };

  const { toggledImages, selectionMode, imagesPaging } = imagesStore;
  const isDisabled =
    (selectionMode === 'Select' && toggledImages.length === 0) || (selectionMode === 'Deselect' && toggledImages.length === imagesPaging.totalCount);
  const canUpdateImageSet = permissions.canUpdateImageSet();

  return (
    <>
      {canUpdateImageSet && (
        <div className='select-image-set-type'>
          <Select<ImageSetType>
            placeholder={t('set_as_dots')}
            id='select-image-set-type'
            value={null}
            onChange={(_, v) => {
              void handleImagesSetTypeChanged(v ?? ImageSetType.NotSet);
            }}
            disabled={isDisabled}
          >
            {Object.values(ImageSetType).map((i) => (
              <Option
                value={i}
                key={i}
              >
                {t(`image_set_options.${i}`)}
              </Option>
            ))}
          </Select>
        </div>
      )}
    </>
  );
});
